
interface StickyHeaderProps {
  show: boolean;
  onScrollToSection: (sectionId: string) => void;
}

const StickyHeader = ({ show, onScrollToSection }: StickyHeaderProps) => {
  if (!show) return null;

  return (
    <div className="fixed top-0 left-0 right-0 bg-white shadow-lg z-50 transition-all duration-300">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-blue-800 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-sm">ATP</span>
            </div>
            <span className="font-bold text-blue-800 text-lg">TAX BUNINSS Academia Tributária</span>
          </div>
          
          <div className="flex items-center space-x-6">
            <button
              onClick={() => onScrollToSection('programa')}
              className="text-gray-700 hover:text-blue-800 font-medium transition-colors whitespace-nowrap"
            >
              Programa
            </button>
            <button
              onClick={() => onScrollToSection('beneficios')}
              className="text-gray-700 hover:text-blue-800 font-medium transition-colors whitespace-nowrap"
            >
              Benefícios
            </button>
            <button
              onClick={() => onScrollToSection('inscricao')}
              className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-lg font-semibold transition-colors whitespace-nowrap"
            >
              Inscreva-se Agora
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StickyHeader;
